import { z } from 'zod'

export interface ProviderRequest {
  program_id: number
  email: string
  name: string
}

export interface VendorRequest {
  program_id: number
  email: string | null
  address: string | null
}

export const ProviderResponseSchema = z.object({
  provider_id: z.number().nullable().optional(),
  provider_application_id: z.number().nullable().optional(),
  email: z.string(),
  name: z.string(),
})

export type ProviderResponse = z.infer<typeof ProviderResponseSchema>
